import { contractualAreaMonth } from "./leaseAreaRent.js";
import { actualPayableMonth, monthlyPayableEvidence } from "./monthlyPayable.js";

export const EVEN_INSTALLMENT_LABEL = "even installment (annual / 12)";
export const EVEN_INSTALLMENT_NOTE = "Approximate contractual installments. Within-year steps and abatements can make actual payments differ; precise monthly allocation needs monthly/area-rate source data. Dated credits are shown separately, not deducted from these installments.";
export const MONTHLY_ACTUAL_LABEL = "sourced actual amounts payable";
export const MONTHLY_ACTUAL_NOTE = "Sourced actual amounts payable, net of abatement. Missing payments in a source-backed year display as zero only; they are not recorded source rows. Signed credits are preserved. Lease dates do not restrict source-year coverage.";

export function hasRecordedRentSegments(areas) {
  return (areas || []).some((area) => (area.rentRates || []).length > 0);
}

// Display-only boundary: never add annual/12 to strict month evidence or $/sf.
// Callers supply only an exact-year, nonprojected contractual annual anchor.
export function leaseMonthlyDisplay(areas, year, month, nativeCurrency, anchor, anchorCurrency = nativeCurrency, lease) {
  const evidence = monthlyPayableEvidence(lease, nativeCurrency);
  if (evidence.state !== "empty") return actualPayableMonth(evidence, year, month, nativeCurrency);
  if (hasRecordedRentSegments(areas)) {
    const strict = contractualAreaMonth(areas, year, month, nativeCurrency);
    return { amount: strict.contractual, currency: nativeCurrency, year, month,
      basis: strict.complete ? "area_rates" : "unresolved", approximate: false };
  }
  const annual = anchor == null || anchor === "" || !Number.isFinite(Number(anchor)) || Number(anchor) < 0
    ? null : Number(anchor);
  return { amount: annual == null ? null : annual / 12, currency: anchorCurrency, year, month,
    basis: annual == null ? "unavailable" : "annual_installment", approximate: annual != null,
    annualAnchor: annual };
}
